<template>
  <div class="cheersList">
    <div class="cheersList_header">
      <div class="header_title">
        <h2>応援リスト</h2>
        <p class="header_value">{{ cheersList.length }}件</p>
      </div>
      <BtnToggle v-bind:toggle="toggle" @toggleAction="toggle = $event" />
    </div>
    <div class="cheersList_list_wrapper">
      <ul
        class="cheersList_list"
        v-bind:class="{
          slider: toggle == 'slider',
          column: toggle == 'column',
        }"
      >
        <li class="item" v-for="(item, index) in cheersList" :key="index">
          <div>
            <button
              @click="
                $router.push({ name: 'Challenge', params: { cid: item.id } })
              "
              class="item_title"
            >
              {{ item.data.data.name }}
            </button>
            <div class="item_div">
              <div class="item_graph">
                <div class="graph_img" style="transform: rotate(-90deg)">
                  <svg
                    height="100%"
                    viewBox="0 0 20 20"
                    width="100%"
                    style="overflow: visible"
                  >
                    <circle
                      cx="50%"
                      cy="50%"
                      fill="none"
                      stroke-width="1"
                      r="9"
                      stroke="#E6EAE6"
                    />
                    <circle
                      cx="50%"
                      cy="50%"
                      fill="none"
                      stroke-width="1"
                      r="9"
                      stroke="#F18D5F"
                      stroke-linecap="round"
                      :style="`stroke-dashoffset:${graph_num(
                        item
                      )};stroke-dasharray: 56.5487`"
                    />
                  </svg>
                </div>
                <p class="graph_percentage">
                  <span>{{ graph_percent(item) }}</span
                  >%
                </p>
                <div class="graph_detail">
                  <p>今のペース</p>
                  <p class="fraction">
                    <span>{{ graph_mai(item) }}</span
                    >枚/<span>{{ graph_day(item) }}</span
                    >日
                  </p>
                </div>
                <button
                  class="graph_btn_icon"
                  @click="
                    $route.params.userId == item.data.host
                      ? false
                      : $router.push({
                          name: 'User',
                          params: {
                            userId: item.data.host,
                          },
                        })
                  "
                >
                  <p>
                    <img :src="item.profile.icon" :alt="item.profile.name" />
                  </p>
                </button>
              </div>
            </div>
            <button
              class="item_btn_cheer"
              @click="
                maiSend(uid, uname, item.data.host, item.profile.name, item.id)
              "
              :disabled="sendMai"
            >
              <p>応援</p>
              <i class="fas fa-rocket"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BtnToggle from "@/components/parts/BtnToggle";
import firebaseUtil from "@/firebase";
import store from "@/store";

export default {
  components: {
    BtnToggle,
  },
  props: ["uid", "uname"],
  data() {
    return {
      newPost: false,
      toggle: "slider",
      cheersList: false,
      sendMai: false,
    };
  },
  computed: {
    cheersListWatch() {
      return store.getters.cheersList;
    },
  },
  watch: {
    cheersListWatch(data) {
      this.cheersList = data;
    },
  },
  methods: {
    graph_num(data) {
      // let low = 56;
      // let add = 56 / data.data.data.goal;
      let max = 56 - (56 / data.data.data.goal) * data.data.post;
      return max;
      // let int = setInterval(() => {
      //   if (low <= max) {
      //     return (low += add);
      //   } else {
      //     clearInterval(int);
      //   }
      // }, 1000);
    },
    graph_percent(data) {
      return data.data.post == 0
        ? 0
        : (data.data.post / data.data.data.goal) * 100;
    },
    graph_mai(data) {
      // 結果
      return data.data.post;
    },
    graph_day(data) {
      // 結果
      let diff =
        new Date().getTime() -
        new Date(data.data.created.seconds * 1000).getTime();
      let between = Math.floor(diff / 86400000);
      return between;
    },
    displayTime(unixTime) {
      var date = new Date(unixTime);
      var diff = new Date().getTime() - date.getTime();
      var d = new Date(diff);

      if (d.getUTCFullYear() - 1970) {
        return d.getUTCFullYear() - 1970 + "年前";
      } else if (d.getUTCMonth()) {
        return d.getUTCMonth() + "ヶ月前";
      } else if (d.getUTCDate() - 1) {
        return d.getUTCDate() - 1 + "日前";
      } else if (d.getUTCHours()) {
        return d.getUTCHours() + "時間前";
      } else if (d.getUTCMinutes()) {
        return d.getUTCMinutes() + "分前";
      } else {
        return d.getUTCSeconds() + "秒前";
      }
    },
    maiSend(uid, name, to_uid, to_name, cid) {
      // maiを送れるのは1秒に一回まで
      let count = 1;
      firebaseUtil
        .setChallengeMai(uid, name, to_uid, to_name, cid, count)
        .then(() => {
          this.sendMai = true;
          setTimeout(() => {
            this.sendMai = false;
          }, 1000);
        });
    },
  },
};
</script>

<style lang="scss">
.cheersList {
  @include Section_padding();
  &_header {
    @include Section_header();
  }
  &_list {
    margin-top: 60px;
    width: calc(100% + 9.2vw);
    margin-left: -4.6vw;
    overflow: auto hidden;
    padding: 0 4.6vw;
    &.column {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(246px, 246px));
      grid-gap: 20px;
      justify-content: center;
    }
    &.slider {
      display: flex;
      .item {
        width: 246px;
        min-width: 246px;
        margin-right: 20px;
      }
    }
    .item {
      & > div {
        width: 246px;
        min-width: 246px;
        padding: 20px;
        background-color: #fff;
        box-shadow: $btn_shadow;
        border-radius: 4px;
      }
      .graph_img {
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
      }
      &_title {
        text-align: center;
        @include fz(16);
        @include text_overflow(2);
        @include pc {
          &:hover {
            text-decoration: underline;
          }
        }
      }
      &_div {
        text-align: center;
        @include challenge_graph(160px, 24, 18);
        margin: 20px auto;
      }
      &_btn_cheer {
        @include cheer_btn();
        position: relative;
        margin: 0 auto;
      }
      &_btn_chip {
        @include icon(40px);
        position: absolute;
        right: 0;
        bottom: 24px;
      }
    }
    @include sp {
      width: 104%;
      margin-left: -2%;
      margin-top: 0;
      padding: 20px 0;
      &.column {
        justify-content: center;
      }
    }
  }
}
</style>